export class Version {
    constructor(
        public Id: number = 0,
        public VersionName: string = '',
        public VersionNumber: string = '',
        public ReleaseDate: Date = new Date(2000,1,1),
        public ReleaseNotes: string = '',
        public EngrNotes: string = '',
        public Status: number = 0,
        public Url: string = '',
        public Hash: string = '')
    { }
}



// WEBPACK FOOTER //
// ./Client/app/models/Version.ts